<template>
  <div class="container-fluid mt-6 px-5">
    <div id="lower-div" class="row mt-3">
      <div class="card mb-4">
        <div v-loading="loading">
          <div class="p-2" m="4">
            <div class="card-body px-0 pt-0 pb-3">
              <titles text="Debitor borclar jurnalı" />
              <hr style="margin-top:0;margin-bottom: 15px;" />
              <div class="mb-3 d-flex justify-content-start align-items-center gap-2">
                <el-input v-model="searchText" size="large" type="text" placeholder="Axtarış" style="width: 220px" />
                <soft-button type="button" @click="onSearch(1)">
                  <i class="fas fa-search"></i> Axtar
                </soft-button>
                <soft-button type="button" class="btn-excel" @click="exportToExcel">
                  <i class="fas fa-file-excel"></i>
                </soft-button>
              </div>
              <debtor-journal-table :data="debtors" :total="total" :page-size="pageSize" :page="page"
                @sms="openSendSmsDialog" @page-change="onPageChange" />
            </div>
          </div>
        </div>
      </div>
      <el-dialog v-model="isSendSmsDialogOpen" width="30%" title="Yeni mesaj">
        <div class="card-body pt-0">
          <div v-if="loadingLogs" class="mb-3">
            <el-skeleton rows="1" animated />
          </div>
          <div v-if="smsLogs.length" class="mb-3">
            <div class="form-label mb-1">Göndərilmiş mesajlar:</div>
            <div style="padding-left:7px; margin-bottom: 0;">
              <div v-for="(log, idx) in smsLogs" :key="log.id" style="font-size: 12px; line-height: 1.8;">
                {{ idx + 1 }}. {{ formatDateTime(log.logDate) }} {{ log.createUserName }}
              </div>
            </div>
          </div>
          <div v-else class="mb-3" style="color:#888; font-size:13px;">
            SMS göndərilməyib
          </div>
          <div class="row">
            <div class="col-12 mt-2">
              <label class="form-label">Şablon</label>
              <el-select v-model="selectedTemplateId" placeholder="Seçin" size="large" style="width: 100%;"
                @change="onTemplateChange">
                <el-option v-for="tpl in smsTemplates" :key="tpl.id" :label="tpl.name" :value="tpl.id" />
              </el-select>
            </div>
            <div class="col-12 mt-3">
              <label class="form-label">Mesaj</label>
              <el-input v-model="smsMessageText" class="custom-readonly-message" disabled type="textarea" rows="4"
                size="large" />
            </div>
          </div>
          <div class="d-flex justify-content-end mt-4">
            <soft-button type="button" @click="sendSmsMessage">Göndər</soft-button>
            &nbsp;
            &nbsp;
            <soft-button type="button" color="secondary" @click="isSendSmsDialogOpen = false">İmtina</soft-button>
          </div>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import Titles from '@/project/Components/Titles.vue'
import SoftButton from "@/components/SoftButton.vue"
import DebtorJournalTable from '@/project/Components/Tables/DebtorJournalTable.vue'
import * as XLSX from "xlsx"
import { GetDebtJournal } from '@/project/Source/journals'
import { CreateMessageLog, GetMessageLogsByParticipant } from '@/project/Source/messagelogs'
import { GetMessageTemplates } from '@/project/Source/classifiers'
// import { SendSms } from '@/project/Source/sms';

export default {
  components: { Titles, SoftButton, DebtorJournalTable },
  data() {
    return {
      debtors: [],
      total: 0,
      page: 1,
      pageSize: 20,
      loading: false,
      searchText: null,
      currentDebtor: null,
      isSendSmsDialogOpen: false,
      smsTemplates: [],
      selectedTemplateId: null,
      smsMessageText: '',
      smsLogs: [],
      loadingLogs: false,
    }
  },
  computed: {
    totalDebt() {
      return this.debtors.reduce((sum, d) => sum + Number(d.debt), 0)
    }
  },
  mounted() {
    this.onSearch()
    this.loadTemplates();
  },
  methods: {
    formatDateTime(dt) {
      if (!dt) return "-";
      const d = new Date(dt);
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const yyyy = d.getFullYear();
      const hh = String(d.getHours()).padStart(2, '0');
      const min = String(d.getMinutes()).padStart(2, '0');
      return `${dd}.${mm}.${yyyy} ${hh}:${min}`;
    },

    async openSendSmsDialog(debtor) {
      this.currentDebtor = debtor;
      this.selectedTemplateId = null;
      this.smsMessageText = '';
      this.isSendSmsDialogOpen = true;
      this.smsLogs = [];
      this.loadingLogs = true;
      try {
        const res = await GetMessageLogsByParticipant(debtor.participantId);
        this.smsLogs = res.data.data;
      } finally {
        this.loadingLogs = false;
      }
    },
    formatDate(dt) {
      if (!dt) return "-";
      const d = new Date(dt);
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const yyyy = d.getFullYear();
      return `${dd}.${mm}.${yyyy}`;
    },


    cleanAz(text = '') {
      return text
        .replace(/Ə/g, 'A').replace(/ə/g, 'a')
        .replace(/Ö/g, 'O').replace(/ö/g, 'o')
        .replace(/Ü/g, 'U').replace(/ü/g, 'u')
        .replace(/I/g, 'İ').replace(/ı/g, 'i')
        .replace(/Ğ/g, 'G').replace(/ğ/g, 'g')
        .replace(/Ç/g, 'C').replace(/ç/g, 'c');
    },

    onTemplateChange() {
      const tpl = this.smsTemplates.find(x => x.id === this.selectedTemplateId);
      if (!tpl) {
        this.smsMessageText = '';
        return;
      }

      this.smsMessageText = tpl.description
        .replace(/@debtor/g, this.cleanAz(this.currentDebtor.defendant))
        .replace(/@subrogationNumber/g, this.currentDebtor.subrogationNumber)
        .replace(/@amount/g, this.currentDebtor.debt);
    },

    async loadTemplates() {
      const response = await GetMessageTemplates();
      this.smsTemplates = response.data.data;
    },

    async onSearch(page = 1) {
      this.loading = true;
      try {
        const response = await GetDebtJournal({
          page,
          pageSize: this.pageSize,
          searchText: this.searchText || ''
        });
        const result = response.data.data;

        for (const debtor of result) {
          const logs = await GetMessageLogsByParticipant(debtor.participantId);
          const data = logs.data.data;
          const sendLogs = data.filter(x => x.logType === 1);
          if (sendLogs.length > 0) {
            debtor.lastSmsDate = sendLogs
              .map(x => x.lastSmsDate || x.logDate)
              .filter(Boolean)
              .sort((a, b) => new Date(b) - new Date(a))[0];
          } else {
            debtor.lastSmsDate = null;
          }
        }

        this.debtors = result;
        this.total = result.length > 0 ? result[0].total : 0;
        this.page = page;
      } finally {
        this.loading = false;
      }
    },
    onPageChange(page) {
      this.onSearch(page)
    },
    exportToExcel() {
      if (!this.debtors.length) return;

      const rows = this.debtors.map(d => ({
        "Subroqasiya №": d.subrogationNumber,
        "Mərhələ": d.stageLabel || d.stage,
        "Cavabdeh": d.defendant,
        "Borc (AZN)": Number(d.debt),
        "Ümumi borc (AZN)": Number(d.totalDebt),
        "Tarix": d.date ? this.formatDate(d.date) : "-",
        "Əlaqə nömrəsi": d.phone || "-",
        "SMS göndərilmə tarixi": d.lastSmsDate ? this.formatDateTime(d.lastSmsDate) : "-"
      }));

      rows.push({
        "Subroqasiya №": "",
        "Mərhələ": "",
        "Cavabdeh": "",
        "Borc (AZN)": "",
        "Ümumi borc (AZN)": "",
        "Tarix": "",
        "Əlaqə nömrəsi": "",
        "SMS göndərilmə tarixi": ""
      });

      const ws = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Debitor borclar");
      XLSX.writeFile(wb, `debitor_borclar_jurnali_${new Date().toISOString().slice(0, 10)}.xlsx`);
    },
    async sendSmsMessage() {
      if (!this.smsMessageText.trim()) {
        this.$message.warning('Mesaj boş ola bilməz!');
        return;
      }

      if (!this.currentDebtor) return;


      try {
        // const template = this.smsTemplates.find(x => x.id === this.selectedTemplateId);
        // await SendSms({
        //   phone: this.currentDebtor.phone,
        //   message: this.smsMessageText,
        //   title: template ? template.name : "",
        //   insurancecompany: "Test Sığorta", 
        // }); 
        this.$message.success('SMS uğurla göndərildi!');

        await CreateMessageLog({
          participantId: this.currentDebtor.participantId,
          logType: 1,
          subrogationId: this.currentDebtor.subrogationId,
          user: this.$store.state.user.id,
        });

        this.isSendSmsDialogOpen = false;
        await this.onSearch(this.page)
      } catch (e) {
        this.$message.error('SMS göndərmək mümkün olmadı!');
      }
    },
  }
}
</script>
<style scoped>
::v-deep(.custom-readonly-message .el-textarea__inner) {
  background-color: #f0f0f0 !important;
  color: #222 !important;
  opacity: 1 !important;
  cursor: not-allowed !important;
}
</style>